<div class="trust-fields-container">
  <div *ngIf="displayFromTrustFields" class="trust-source-account">
    <div *ngIf="displayToTrustFields" class="medium-bottom-spacer container">
      <span id="subtitle">Source account</span>
    </div>
    <mm-trust-income-principal [parentForm]="parentForm" [availableCash]="availableCash"
      [datePickerControlName]="datePickerControlName" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
      [incomePercent$]="trustIncomePercent$" [principalPercent$]="trustPrincipalPercent$" [ptrsInfo$]="ptrsInfo$"
      [component]="'source'" [isFromAccount]="true" class="big-bottom-spacer trust-income-principal">
    </mm-trust-income-principal>
    <mm-trust-tax-category id="trust-tax-category" [parentForm]="parentForm" [taxCategories]="taxCategories$"
      class="big-bottom-spacer">
    </mm-trust-tax-category>
    <mm-trust-tax-code id="trust-tax-code" [parentForm]="parentForm" [codes]="taxCodes$" class="big-bottom-spacer">
    </mm-trust-tax-code>
    <mm-trust-paid-for *ngIf="showPaidFor" id="trust-paid-for" [parentForm]="parentForm" class="big-bottom-spacer">
    </mm-trust-paid-for>
  </div>
  <sdps-divider *ngIf="displayFromTrustFields && displayToTrustFields" variation="secondary"></sdps-divider>
  <div *ngIf="displayToTrustFields" class="trust-receiving-account">
    <div *ngIf="displayFromTrustFields && displayToTrustFields" class="medium-bottom-spacer container">
      <span id="subtitle">Receiving account</span>
    </div>
    <mm-trust-income-principal [parentForm]="parentForm" [availableCash]="availableCash"
      [datePickerControlName]="datePickerControlName" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
      [incomePercent$]="trustIncomeToPercent$" [principalPercent$]="trustPrincipalToPercent$" [ptrsInfo$]="ptrsInfo$"
      [component]="'receiving'" [isFromAccount]="false" class="big-bottom-spacer trust-income-principal">
    </mm-trust-income-principal>
    <div class="trust-deposit-code">
      <mm-trust-deposit-code id="trust-deposit-code" [parentForm]="parentForm">
      </mm-trust-deposit-code>
      <span class="trust-copy big-bottom-spacer">
        {{trustReceivingAccountCopy}}
      </span>
    </div>
    <sdps-divider *ngIf="displayFromTrustFields && displayToTrustFields" variation="secondary"></sdps-divider>
  </div>
  <mm-trust-comment id="trust-comment" [parentForm]="parentForm" class="big-bottom-spacer"></mm-trust-comment>
</div>